export default [
    {
        path: '/product-feed/list',
        name: 'product_feed_list',
        component: () => import('@src/product-feed/product-feed-list'),
        meta: {
            title: 'Produktfeeds',
            role: 'ROLE_LIST_PRODUCT_FEED',
        },
    },
    {
        path: '/product-feed/:id?/:tab?',
        name: 'product_feed',
        component: () => import('@src/product-feed/product-feed'),
        props(route) {
            return { id: route.params.id ? Number.parseInt(route.params.id) : null };
        },
        meta: {
            title: 'Produktfeed bearbeiten',
            role: 'ROLE_EDIT_PRODUCT_FEED',
        },
    },
];
